export default "__VITE_ASSET__CZ7sAiY9__"